import { createVariable, isVariable } from "../createVariable.js";
import { GetThemeUnwrapped } from "../hooks/getThemeUnwrapped.js";
function ensureThemeVariable(theme, key) {
  const val = theme[key];
  const themeKey = key;
  if (!isVariable(val)) {
    theme[key] = createVariable({
      key: themeKey,
      name: themeKey,
      val
    });
  } else {
    if (val.name !== themeKey) {
      theme[key] = createVariable({
        key: val.name,
        name: themeKey,
        val: val.val
      });
    }
  }
}
function proxyThemeToParents(themeName, theme, themes) {
  const cur = [];
  const parents = themeName.split("_").slice(0, -1).map((part) => {
    cur.push(part);
    return cur.join("_");
  });
  const numParents = parents.length;
  return new Proxy(theme, {
    get(target, key) {
      if (key === GetThemeUnwrapped)
        return theme;
      if (numParents && !Reflect.has(target, key)) {
        for (let i = numParents - 1; i >= 0; i--) {
          const parent = themes[parents[i]];
          if (!parent)
            continue;
          if (Reflect.has(parent, key)) {
            return Reflect.get(parent, key);
          }
        }
      }
      return Reflect.get(target, key);
    }
  });
}
export {
  ensureThemeVariable,
  proxyThemeToParents
};
//# sourceMappingURL=themes.js.map
